// Functions to assist in applying the classes necessary for the `scale-up-down` and `slide-left-right`
// SCSS mixins located in `./src/scss/utils/animations/_container-movement.scss`.

import { debounce } from './debounce'

window['gmVhListenerAdded'] =
	window['gmVhListenerAdded'] ||
	(() => {
		// Using code from here https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
		// I hate Apple and Safari and their dumb choices.
		const setVh = () => {
			const vh = window.innerHeight * 0.01
			document.documentElement.style.setProperty('--vh', `${vh}px`)
		}

		window.addEventListener('load', debounce(setVh, 200), { once: true })
		window.addEventListener('resize', debounce(setVh, 200))

		return true
	})()

/**
 * Applies the "opening" class and adds an "animationend" event listener that one fires
 * once that removes the "opening" class and adds the "open" class.
 * @param container The container element to apply the animations to.
 * @param callback A callback to run when the animation ends.
 * @returns the callback passed to the event listener. Can be used to remove the callback and cancel the animation callback.
 */
export const animateOpen = (container: HTMLElement, callback?: () => void): (() => void) => {
	const animationEndCallback = () => {
		container.classList.remove('opening')
		container.classList.add('open')
		if (callback) callback()
	}

	container.addEventListener('animationend', animationEndCallback, {
		once: true,
	})
	container.classList.add('opening')

	return animationEndCallback
}

/**
 * Applies the "closing" class and adds an "animationend" event listener that one fires
 * once that removes the "closing" and "open" class.
 * @param container The container element to apply the animations to.
 * @param callback A callback to run when the animation ends.
 * @returns the callback passed to the event listener. Can be used to remove the callback and cancel the animation callback.

 */
export const animateClose = (container: HTMLElement, callback?: () => void): (() => void) => {
	const animationEndCallback = () => {
		container.classList.remove('closing')
		if (callback) callback()
	}

	container.addEventListener('animationend', animationEndCallback, {
		once: true,
	})
	container.classList.remove('open')
	container.classList.add('closing')

	return animationEndCallback
}
